/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowUpFromDoubleLine: {
  name: 'arrow-up-from-double-line';
  data: string;
} = {
  name: 'arrow-up-from-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 15V7.414l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 7.414V15H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4Zm-7 4a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z" fill="currentColor"/></svg>`,
};
